import { useState } from 'react';

const CollapsiblePanel = (props) => {
  const {
    title,
    heading,
    children,
    className = '',
  } = props;
  const resolvedTitle = title || heading;
  const resolvedDefaultOpen = props.defaultOpen ?? false;
  const resolvedTrailing = props.trailing ?? null;
  const [open, setOpen] = useState(resolvedDefaultOpen);
  const toggle = () => setOpen((value) => !value);
  const onTitleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggle();
    }
  };

  return (
    <div className={`bg-white rounded-xl border border-gray-100 mb-4 md:mb-6 ${className}`}>
      <div
        onClick={toggle}
        className="px-3 sm:px-4 md:px-5 py-2.5 sm:py-3 cursor-pointer"
      >
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
          <h2
            tabIndex={0}
            aria-expanded={open}
            onKeyDown={onTitleKeyDown}
            className="text-sm sm:text-base font-semibold text-gray-800 min-w-0 break-words leading-snug outline-none"
          >
            {resolvedTitle}
          </h2>
          {resolvedTrailing ? (
            <div
              className="min-w-0 w-full sm:w-auto sm:max-w-[72%] sm:flex sm:justify-end"
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
            >
              {resolvedTrailing}
            </div>
          ) : null}
        </div>
      </div>
      {open && <div className="px-3 sm:px-4 md:px-5 pb-3 sm:pb-4 md:pb-5">{children}</div>}
    </div>
  );
};

export default CollapsiblePanel;
